import React from 'react';
import { motion } from 'framer-motion';
const bonos = [{
  num: '🎁 01',
  title: '40+ Prompts universitarios',
  desc: 'Organizados por tipo de tarea. Para cualquier materia, cualquier carrera.',
  val: '$8.000'
}, {
  num: '🎁 02',
  title: 'Guía paso a paso desde cero',
  desc: 'Arrancás sin saber nada de IA y en una tarde ya tenés el sistema andando.',
  val: '$6.000'
}, {
  num: '🎁 03',
  title: 'Plantillas de organización',
  desc: 'Cronogramas y estructuras listas para no perder tiempo organizándote.',
  val: '$4.000'
}, {
  num: '🎁 04',
  title: 'Sistema para TPs y trabajos',
  desc: 'El flujo exacto para estructurar, investigar y redactar sin bloquearte.',
  val: '$7.000'
}, {
  num: '🎁 05',
  title: 'Prompts para exposiciones orales',
  desc: 'Prepará cualquier oral en 1 hora. Con argumentos, ejemplos y respuestas a preguntas del profesor.',
  val: '$5.000'
}, {
  num: '🎁 06',
  title: 'Actualizaciones de por vida',
  desc: 'La IA evoluciona. El sistema también. Cada mejora relevante para estudiantes, la recibís sin pagar nada más.',
  val: '$∞'
}];
export function Bonos() {
  return <section id="bonos" className="py-[60px] md:py-[80px]" data-id="element-25">
      <div className="max-w-[800px] mx-auto px-5" data-id="element-26">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[clamp(28px,5vw,42px)] font-black text-center leading-[1.2] mb-10" data-id="element-27">
          🎁 Esto es lo que recibís hoy
        </motion.h2>

        <div className="flex flex-col gap-4 mb-10" data-id="element-28">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-navy-2 border-[1.5px] border-brand-gold/35 rounded-xl p-6 flex flex-col sm:flex-row items-start gap-5" data-id="element-29">
              <div className="bg-brand-gold text-navy text-[13px] font-black py-1.5 px-3 rounded-lg shrink-0 sm:mt-0.5" data-id="element-30">
                {bono.num}
              </div>
              <div className="flex-grow" data-id="element-31">
                <h3 className="text-base font-extrabold mb-1.5 leading-[1.3]" data-id="element-32">
                  {bono.title}
                </h3>
                <p className="text-sm text-brand-gray leading-[1.6] mb-3" data-id="element-33">
                  {bono.desc}
                </p>
                <div className="flex items-center gap-2 text-[13px] font-medium" data-id="element-34">
                  <span className="text-brand-gray" data-id="element-35">
                    Valor: <span className="line-through" data-id="element-36">{bono.val}</span>
                  </span>
                  <span className="text-brand-gray" data-id="element-37">→</span>
                  <span className="inline-flex items-center bg-brand-success/10 border border-brand-success/30 text-brand-success text-xs font-bold py-1 px-2.5 rounded-full" data-id="element-38">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-[#1a1200] to-[#2a1c00] border-[1.5px] border-brand-gold rounded-xl p-6" data-id="element-39">
          <p className="text-[16px] text-brand-gray mb-1" data-id="element-40">
            Valor total bonos: <span className="line-through" data-id="element-41">$30.000 ARS</span>
          </p>
          <div className="text-[clamp(24px,4vw,32px)] font-black text-brand-gold" data-id="element-42">
            → GRATIS con tu sistema
          </div>
        </motion.div>
      </div>
    </section>;
}